function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBaseLogoNetwork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "72px",
    height: "72px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.02
    },
    fill: "#065aff",
    d: "M 20.5,-0.5 C 21.1667,-0.5 21.8333,-0.5 22.5,-0.5C 21.8333,0.833333 21.1667,0.833333 20.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.951
    },
    fill: "#1052ff",
    d: "M 26.5,-0.5 C 32.5,-0.5 38.5,-0.5 44.5,-0.5C 47.6777,1.00862 51.0111,2.34196 54.5,3.5C 54.5,4.16667 54.8333,4.5 55.5,4.5C 56.795,5.48837 58.1283,6.48837 59.5,7.5C 59.5,8.16667 59.8333,8.5 60.5,8.5C 60.5,9.16667 60.8333,9.5 61.5,9.5C 61.5,10.1667 61.8333,10.5 62.5,10.5C 62.5,11.1667 62.8333,11.5 63.5,11.5C 64.5116,12.8717 65.5116,14.205 66.5,15.5C 66.5,16.1667 66.8333,16.5 67.5,16.5C 67.6596,18.153 68.3263,19.4863 69.5,20.5C 69.595,22.7857 70.2616,24.7857 71.5,26.5C 71.5,32.5 71.5,38.5 71.5,44.5C 70.2616,46.2143 69.595,48.2143 69.5,50.5C 68.6618,50.8417 68.3284,51.5084 68.5,52.5C 67.6618,52.8417 67.3284,53.5084 67.5,54.5C 66.8333,54.5 66.5,54.8333 66.5,55.5C 65.6618,55.8417 65.3284,56.5084 65.5,57.5C 64.8333,57.5 64.5,57.8333 64.5,58.5C 63.8333,58.5 63.5,58.8333 63.5,59.5C 62.8333,59.5 62.5,59.8333 62.5,60.5C 61.8333,60.5 61.5,60.8333 61.5,61.5C 60.8333,61.5 60.5,61.8333 60.5,62.5C 59.8333,62.5 59.5,62.8333 59.5,63.5C 58.8333,63.5 58.5,63.8333 58.5,64.5C 57.8333,64.5 57.5,64.8333 57.5,65.5C 56.5084,65.3284 55.8417,65.6618 55.5,66.5C 54.8333,66.5 54.5,66.8333 54.5,67.5C 53.5084,67.3284 52.8417,67.6618 52.5,68.5C 51.5084,68.3284 50.8417,68.6618 50.5,69.5C 48.2143,69.595 46.2143,70.2616 44.5,71.5C 38.5,71.5 32.5,71.5 26.5,71.5C 24.7857,70.2616 22.7857,69.595 20.5,69.5C 19.4863,68.3263 18.153,67.6596 16.5,67.5C 16.5,66.8333 16.1667,66.5 15.5,66.5C 14.205,65.5116 12.8717,64.5116 11.5,63.5C 11.5,62.8333 11.1667,62.5 10.5,62.5C 10.1667,61.5 9.5,60.8333 8.5,60.5C 8.5,59.8333 8.16667,59.5 7.5,59.5C 6.48837,58.1283 5.48837,56.795 4.5,55.5C 4.5,54.8333 4.16667,54.5 3.5,54.5C 3.67158,53.5084 3.33825,52.8417 2.5,52.5C 2.67158,51.5084 2.33825,50.8417 1.5,50.5C 1.40505,48.2143 0.738379,46.2143 -0.5,44.5C -0.5,38.5 -0.5,32.5 -0.5,26.5C 0.738379,24.7857 1.40505,22.7857 1.5,20.5C 2.67373,19.4863 3.3404,18.153 3.5,16.5C 4.16667,16.5 4.5,16.1667 4.5,15.5C 5.48837,14.205 6.48837,12.8717 7.5,11.5C 8.16667,11.5 8.5,11.1667 8.5,10.5C 9.16667,10.5 9.5,10.1667 9.5,9.5C 10.1667,9.5 10.5,9.16667 10.5,8.5C 11.1667,8.5 11.5,8.16667 11.5,7.5C 12.8717,6.48837 14.205,5.48837 15.5,4.5C 16.1667,4.5 16.5,4.16667 16.5,3.5C 19.9889,2.34196 23.3223,1.00862 26.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.016
    },
    fill: "#064dff",
    d: "M 48.5,-0.5 C 49.1667,-0.5 49.8333,-0.5 50.5,-0.5C 49.8333,0.833333 49.1667,0.833333 48.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.016
    },
    fill: "#0340ff",
    d: "M 16.5,3.5 C 15.8333,3.5 15.5,3.83333 15.5,4.5C 13.0248,4.2533 13.0248,3.58664 15.5,2.5C 16.1067,2.62358 16.44,2.95691 16.5,3.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#0741ff",
    d: "M 54.5,3.5 C 55.4971,2.28749 56.4971,2.45415 57.5,4C 56.9056,4.46434 56.2389,4.63101 55.5,4.5C 54.8333,4.5 54.5,4.16667 54.5,3.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#072dff",
    d: "M 59.5,7.5 C 61.6636,6.88171 63.3303,7.88171 64.5,10.5C 64.3764,11.1067 64.0431,11.44 63.5,11.5C 62.8333,11.5 62.5,11.1667 62.5,10.5C 61.8333,10.5 61.5,10.1667 61.5,9.5C 60.8333,9.5 60.5,9.16667 60.5,8.5C 59.8333,8.5 59.5,8.16667 59.5,7.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.016
    },
    fill: "#093cff",
    d: "M 11.5,7.5 C 10.8333,7.5 10.5,7.83333 10.5,8.5C 9.83333,8.5 9.5,8.83333 9.5,9.5C 9.16667,9.5 8.83333,9.5 8.5,9.5C 8.66823,6.9486 9.66823,6.28194 11.5,7.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.016
    },
    fill: "#063cff",
    d: "M 8.5,9.5 C 8.5,9.83333 8.5,10.1667 8.5,10.5C 7.83333,10.5 7.5,10.8333 7.5,11.5C 6.24258,10.3774 6.57591,9.71073 8.5,9.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbfbff",
    d: "M 43.5,36.5 C 43.5,35.5 43.5,34.5 43.5,33.5C 33.0131,32.5056 22.3464,32.1722 11.5,32.5C 11.5,31.1667 11.5,29.8333 11.5,28.5C 16.2506,14.7838 25.9173,8.61713 40.5,10C 60.0495,17.3178 65.5495,30.4845 57,49.5C 46.6056,61.5646 34.439,63.7313 20.5,56C 14.6696,51.1719 11.3363,45.0052 10.5,37.5C 21.6794,37.8279 32.6794,37.4946 43.5,36.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.02
    },
    fill: "#1346ff",
    d: "M 4.5,15.5 C 3.83333,15.5 3.5,15.8333 3.5,16.5C 2.28749,15.5029 2.45415,14.5029 4,13.5C 4.46434,14.0944 4.63101,14.7611 4.5,15.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.016
    },
    fill: "#0439ff",
    d: "M 67.5,16.5 C 66.8333,16.5 66.5,16.1667 66.5,15.5C 66.7467,13.0248 67.4134,13.0248 68.5,15.5C 68.3764,16.1067 68.0431,16.44 67.5,16.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.018
    },
    fill: "#0054ff",
    d: "M 70.5,20.5 C 70.1667,20.5 69.8333,20.5 69.5,20.5C 69.8333,17.8333 70.1667,17.8333 70.5,20.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.024
    },
    fill: "#0b42ff",
    d: "M 1.5,20.5 C 1.16667,20.5 0.833333,20.5 0.5,20.5C 0.833333,17.8333 1.16667,17.8333 1.5,20.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.027
    },
    fill: "#004dff",
    d: "M -0.5,20.5 C -0.166667,20.5 0.166667,20.5 0.5,20.5C 0.67158,21.4916 0.338246,22.1583 -0.5,22.5C -0.5,21.8333 -0.5,21.1667 -0.5,20.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.02
    },
    fill: "#065aff",
    d: "M 70.5,20.5 C 70.8333,20.5 71.1667,20.5 71.5,20.5C 71.5,21.1667 71.5,21.8333 71.5,22.5C 70.6618,22.1583 70.3284,21.4916 70.5,20.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d1d7ff",
    d: "M 11.5,28.5 C 11.5,29.8333 11.5,31.1667 11.5,32.5C 22.3464,32.1722 33.0131,32.5056 43.5,33.5C 32.5,33.5 21.5,33.5 10.5,33.5C 10.2155,31.5853 10.5489,29.9187 11.5,28.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#003bff",
    d: "M 10.5,33.5 C 21.5,33.5 32.5,33.5 43.5,33.5C 43.5,34.5 43.5,35.5 43.5,36.5C 32.495,36.6665 21.495,36.4998 10.5,36C 21.1667,35.6667 31.8333,35.3333 42.5,35C 31.6588,34.8304 20.9921,34.3304 10.5,33.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#0051ff",
    d: "M -0.5,48.5 C 0.338246,48.8417 0.67158,49.5084 0.5,50.5C 0.166667,50.5 -0.166667,50.5 -0.5,50.5C -0.5,49.8333 -0.5,49.1667 -0.5,48.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.016
    },
    fill: "#064dff",
    d: "M 71.5,48.5 C 71.5,49.1667 71.5,49.8333 71.5,50.5C 71.1667,50.5 70.8333,50.5 70.5,50.5C 70.3284,49.5084 70.6618,48.8417 71.5,48.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.018
    },
    fill: "#0054ff",
    d: "M 69.5,50.5 C 69.8333,50.5 70.1667,50.5 70.5,50.5C 70.6716,51.4916 70.3382,52.1583 69.5,52.5C 69.5,51.8333 69.5,51.1667 69.5,50.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#0b2bff",
    d: "M 0.5,50.5 C 0.833333,50.5 1.16667,50.5 1.5,50.5C 1.5,51.1667 1.5,51.8333 1.5,52.5C 0.661754,52.1583 0.32842,51.4916 0.5,50.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#126cff",
    d: "M 1.5,52.5 C 1.83333,52.5 2.16667,52.5 2.5,52.5C 2.5,53.1667 2.5,53.8333 2.5,54.5C 1.66175,54.1583 1.32842,53.4916 1.5,52.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#0b2bff",
    d: "M 68.5,52.5 C 68.8333,52.5 69.1667,52.5 69.5,52.5C 69.6716,53.4916 69.3382,54.1583 68.5,54.5C 68.5,53.8333 68.5,53.1667 68.5,52.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#1544ff",
    d: "M 2.5,54.5 C 2.83333,54.5 3.16667,54.5 3.5,54.5C 4.16667,54.5 4.5,54.8333 4.5,55.5C 3.69871,57.7929 3.03204,57.4596 2.5,54.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#0741ff",
    d: "M 67.5,54.5 C 67.8333,54.5 68.1667,54.5 68.5,54.5C 68.573,56.0269 67.9063,57.0269 66.5,57.5C 66.5,56.8333 66.5,56.1667 66.5,55.5C 67.1667,55.5 67.5,55.1667 67.5,54.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.02
    },
    fill: "#0065ff",
    d: "M 65.5,57.5 C 65.8333,57.5 66.1667,57.5 66.5,57.5C 66.3147,58.1701 65.9813,58.1701 65.5,57.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.024
    },
    fill: "#0054ff",
    d: "M 64.5,58.5 C 64.8333,58.5 65.1667,58.5 65.5,58.5C 65.3147,59.1701 64.9813,59.1701 64.5,58.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#103dff",
    d: "M 7.5,59.5 C 8.16667,59.5 8.5,59.8333 8.5,60.5C 8.44001,61.0431 8.10667,61.3764 7.5,61.5C 6.22671,60.7435 6.22671,60.0768 7.5,59.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#0b2dff",
    d: "M 63.5,59.5 C 63.8333,59.5 64.1667,59.5 64.5,59.5C 64.5,61.5 63.5,62.5 61.5,62.5C 61.5,62.1667 61.5,61.8333 61.5,61.5C 62.1667,61.5 62.5,61.1667 62.5,60.5C 63.1667,60.5 63.5,60.1667 63.5,59.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#103dff",
    d: "M 10.5,62.5 C 11.1667,62.5 11.5,62.8333 11.5,63.5C 11.44,64.0431 11.1067,64.3764 10.5,64.5C 9.22671,63.7435 9.22671,63.0768 10.5,62.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#0931ff",
    d: "M 60.5,62.5 C 60.8333,62.5 61.1667,62.5 61.5,62.5C 61.5,63.8333 60.8333,64.5 59.5,64.5C 59.5,64.1667 59.5,63.8333 59.5,63.5C 60.1667,63.5 60.5,63.1667 60.5,62.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.024
    },
    fill: "#0054ff",
    d: "M 58.5,64.5 C 58.8333,64.5 59.1667,64.5 59.5,64.5C 59.3147,65.1701 58.9813,65.1701 58.5,64.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.016
    },
    fill: "#003fff",
    d: "M 57.5,65.5 C 57.8333,65.5 58.1667,65.5 58.5,65.5C 58.3147,66.1701 57.9813,66.1701 57.5,65.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.024
    },
    fill: "#0f49ff",
    d: "M 15.5,66.5 C 16.1667,66.5 16.5,66.8333 16.5,67.5C 15.5029,68.7125 14.5029,68.5458 13.5,67C 14.0944,66.5357 14.7611,66.369 15.5,66.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#1544ff",
    d: "M 55.5,66.5 C 56.1667,66.5 56.8333,66.5 57.5,66.5C 57.0269,67.9063 56.0269,68.573 54.5,68.5C 54.5,68.1667 54.5,67.8333 54.5,67.5C 55.1667,67.5 55.5,67.1667 55.5,66.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#126cff",
    d: "M 52.5,69.5 C 52.5,69.1667 52.5,68.8333 52.5,68.5C 53.1667,68.5 53.8333,68.5 54.5,68.5C 54.1583,69.3382 53.4916,69.6716 52.5,69.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.024
    },
    fill: "#0b42ff",
    d: "M 20.5,69.5 C 20.5,69.8333 20.5,70.1667 20.5,70.5C 17.8333,70.1667 17.8333,69.8333 20.5,69.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#0b2bff",
    d: "M 50.5,70.5 C 50.5,70.1667 50.5,69.8333 50.5,69.5C 51.1667,69.5 51.8333,69.5 52.5,69.5C 52.1583,70.3382 51.4916,70.6716 50.5,70.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.027
    },
    fill: "#004dff",
    d: "M 20.5,71.5 C 20.5,71.1667 20.5,70.8333 20.5,70.5C 21.4916,70.3284 22.1583,70.6618 22.5,71.5C 21.8333,71.5 21.1667,71.5 20.5,71.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#0051ff",
    d: "M 48.5,71.5 C 48.8417,70.6618 49.5084,70.3284 50.5,70.5C 50.5,70.8333 50.5,71.1667 50.5,71.5C 49.8333,71.5 49.1667,71.5 48.5,71.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaseLogoNetwork);
export default __webpack_public_path__ + "static/media/base_logo_network.f61034b2dd90e853d0ad4fc65acd1ea5.svg";
export { ForwardRef as ReactComponent };